import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=1f47950c"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=1f47950c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f47950c')) {
      api.createRecord('1f47950c', component.options)
    } else {
      api.reload('1f47950c', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=1f47950c", function () {
      api.rerender('1f47950c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BusinessUnitForm/components/DataForm.vue"
export default component.exports